module.exports = __webpack_public_path__ + "images/feature/two-factor-2-aae952c1abc7019e8506f3c86c35ea36.png";